export const MAX_LEGEND_ITEMS_SELECTED = 10;
export const LINE_CHART_HEIGHT = 344;
export const LINE_CHART_LEGEND_HEIGHT = "248px";
export const LINE_CHART_LEGEND_MIN_WIDTH = 260;
export const LEGEND_GRAPH_GAP = 24;
export const LEGENDS_WITH_VALUE_MAX_WIDTH = 150;
export const TOOLTIP_LEFT_COLUMN_WIDTH = "204px";
export const TOOLTIP_RIGHT_COLUMN_WIDTH = "83px";
